import {BaseActionButton} from './BaseActionButton';

class Clone extends BaseActionButton {
  icon = 'clone';
  tooltip = 'Clone';

  disabled = () => {
    return !this.rackEditorStore.canClone.result;
  };

  error = () => {
    const {canClone: {why}, selection: {nothingSelected}} = this.rackEditorStore;
    return nothingSelected ? null : why;
  };

  onClick = () => {
    const {rackStore, selection} = this.rackEditorStore;
    this.hidePopups(true, true);
    selection.select(...rackStore.cloneSelected(selection.selectedNodesIds));
  };
}

export {Clone};
